import Marquee from "react-fast-marquee";
import { useEffect, useState } from "react";
import { getRates } from "@/lib/api";

const FALLBACK = [
  { from: "USD", to: "NGN", rate: 1585.0 },
  { from: "GBP", to: "KES", rate: 168.42 },
  { from: "EUR", to: "GHS", rate: 14.51 },
  { from: "USD", to: "XOF", rate: 605.2 },
  { from: "CAD", to: "ZAR", rate: 13.24 },
  { from: "AUD", to: "UGX", rate: 2452.1 },
  { from: "EUR", to: "MAD", rate: 10.72 },
  { from: "GBP", to: "NGN", rate: 2014.55 },
  { from: "USD", to: "EGP", rate: 49.3 },
  { from: "CHF", to: "TZS", rate: 2985.0 },
];

export default function RatesMarquee({ variant = "light" }) {
  const [pairs, setPairs] = useState(FALLBACK);
  useEffect(() => {
    getRates()
      .then((d) => Array.isArray(d?.pairs) && setPairs(d.pairs))
      .catch(() => {});
  }, []);

  const isDark = variant === "dark";
  return (
    <section
      className={`py-6 border-y ${
        isDark ? "bg-forest text-canvas border-canvas/10" : "bg-surface text-forest border-forest/10"
      }`}
      data-testid="rates-marquee"
    >
      <div className="flex items-center gap-6 edge-fade marquee-strip">
        <div className={`shrink-0 pl-6 label-eyebrow ${isDark ? "!text-lime" : ""}`}>
          <span className="inline-flex items-center gap-2">
            <span className="live-dot" /> Live mid-market
          </span>
        </div>
        <Marquee gradient={false} speed={38} pauseOnHover>
          {pairs.map((p, i) => (
            <span
              key={`${p.from}-${p.to}-${i}`}
              className={`inline-flex items-center gap-3 pr-10 font-display text-xl md:text-2xl tracking-tight ${
                isDark ? "text-canvas" : "text-forest"
              }`}
              data-testid={`rate-${p.from}-${p.to}`}
            >
              <span className="opacity-70 text-sm font-mono">
                {p.from} → {p.to}
              </span>
              <span>1 = {formatRate(p.rate)}</span>
              <span className={`opacity-30 ${isDark ? "" : ""}`}>·</span>
            </span>
          ))}
        </Marquee>
      </div>
    </section>
  );
}

function formatRate(n) {
  if (n >= 1000) return n.toLocaleString("en-US", { maximumFractionDigits: 2 });
  if (n >= 100) return n.toFixed(2);
  return n.toFixed(3);
}
